export type FetchType = string | FetchArray;
export interface FetchArray extends Array<FetchType> {}

export enum Entitlement {
  AGENT = 'AGENT',
  AGENT_PROXY = 'AGENT_PROXY',
  OPS_PROXY = 'OPS_PROXY',
  WHOLESALE_PROXY = 'WHOLESALE_PROXY',
  DUAL_ROLE = 'DUAL_ROLE',
  TELE_INTERVIEWER = 'TELE_INTERVIEWER',
}

export enum GenesysContext {
  MM_DIRECT = 'MM_DIRECT',
  COVERPATH_AGENT = 'COVERPATH_AGENT',
  COVERPATH_CLIENT = 'COVERPATH_CLIENT',
}

export type GenesysParticipantData = {
  'WP-Authenticated': boolean;
  'WP-Context': GenesysContext;
  'WP-First-Name'?: string;
  'WP-Last-Name'?: string;
  'WP-Email'?: string;
  'WP-Is-1851': boolean;
  'WP-Producer-ID'?: string;
};

export enum ExamVendor {
  APPS = 'APPS',
  ExamOne = 'ExamOne',
}
